export default {
  // 登录、注册
  login: {
    login: '登录',
    regist: '注册',
    test: '登录、注册',
    pwdlogin: '密码登录',
    qrlogin: '扫码登录',
    pwd: '密码',
    remember: '一周内自动登录',
    forgetPwd: '忘记密码',
    loginBtn: '登 录',
    downApp: '下载手机端',
    website: '访问官网',
    qrNote1: '请使用',
    qrNote2: '平台移动端扫描二维码登录',
    userRegist: '用户注册',
    registAccount: '注册账号',
    vCode: '验证码',
    getCode: '获取验证码',
    agree: '我已同意',
    clause: '服务条款',
    clause_err: '请同意服务条款，以及隐私政策！',
    nextStep: '下一步',
    pwdlogint: '已有账号',
    pwdloginy: '立即登录',
    rememberpwd: '想起密码了',
    NOUser: '没有账号？',
    resetPwd: '重置密码 ',
    loginPhone: '登录手机号码 ',
    thank: '感谢您的注册 ',
    note: '相关同事将会对您的信息进行审核，审核通过后会以短信的形式通知到您。 ',
    ok: '好的 ',
    continues: '请完成下列验证后继续 ',
    verifySuccess: '验证成功 ',
    dragPuzzle: '按在左边按钮拖动完成上方拼图 ',
    refurbish: '刷新 ',
    wait: ' 注册中，请稍等 ',
    regain: '后重新获取',
    or: '或',
    thirdpartyscancodelogin: '第三方扫码登录',
    userthirdpartyscancodelogin: '使用第三方账号登录',
    teamfacewechat: '微信公众号',
    followwechatpublicaccount: '关注微信公众号',
    clicknexttoagree: '点击下一步即代表同意',
    returntologinscreen: '返回登录界面',
    teamfacescancodelogin: '扫码登录',
    loginsuccess: '登录成功',
    invalid: '二维码失效',
    // 20201224
    enterprisewechat: '企业微信',
    nail: '钉钉',
    thirdpartylogin: '第三方登录',
    chromeisrecommended: '建议使用谷歌浏览器',
    // 20210526
    placeholder1: '手机号码/邮箱/工号',
    placeholder2: '手机号码/邮箱',
    placeholder: {
      company: '机构名称（必填）',
      name: '姓名（必填）',
      pwd: '登录密码（必填）',
      realm: '公网域名或IP（包含端口且必填）',
      im: '请输入公网域名或IP，用于IM使用'
    },
    error: {
      company: '机构名称最少4位',
      company_empty: '机构名称不能为空',
      name_empty: '姓名不能为空',
      pwd: '密码至少6位',
      pwd_empty: '密码不能为空',
      realm: '地址格式不正确',
      realm_empty: '地址不能为空',
      im: 'IM地址格式不正确',
      im_empty: 'IM地址不能为空',
      // 20210526
      user: '账户格式错误'
    },
    service: {
      header: '服务条款',
      header1: '一、特别声明',
      header2: '二、用户条款',
      header3: '三、知识产权声明',
      header4: '四、用户信息保护',
      header5: '五、有效通知',
      header6: '六、免责声明',
      header7: '七、服务的修改与信息披露',
      header8: '八、法律管辖',
      header9: '隐私政策',
      header10: '我们可能收集的信息',
      header11: '您提供的信息',
      header12: '我们获取的您的信息',
      header13: '我们可能如何使用信息',
      header14: '您如何访问和控制自己的个人信息',
      header15: '我们可能分享的信息',
      header16: '法定披露',
      header17: '信息安全',
      header18: '您分享的信息',
      header19: '您分享的敏感个人信息',
      header20: '您同意按本《隐私政策》所述的目的和方式来处理您的敏感个人信息。',
      header21: '我们可能如何收集信息',
      header22: '我们可能向您发送的邮件和信息',
      header23: '邮件和信息推送',
      header24: '与服务有关的公告',
      header25: '隐私政策的适用范围',
      header26: '请您注意，本《隐私政策》不适用于以下情况：',
      header27: '变更',

      ol1: '1、TeamFace是由深圳市汇聚华企科技有限机构提供，用户必须完全同意所有服务条款才能注册使用。用户在完成全部激活注册程序后，即代表您已充分阅读、理解并接受本条款的全部内容， 本条款即产生法律约束力。您承诺接受并遵守本条款的约定，届时您不应以未阅读本条款的内容或者未获得对您问询的解答等理由，主张本条款无效，或要求撤销本条款。',
      ol2: '2、TeamFace有权根据业务需要酌情修订"条款"，并在其网站上予以公告。如用户不同意相关修订，请用户立即停止使用本服务。经修订的"条款"一经在网站公布，即产生效力。如用户继续使用TeamFace，则将视为用户已接受经修订的"条款"，当用户与TeamFace发生争议时，应以最新的"条款"为准。',
      ol3: '1、服务条款是TeamFace与用户之间的协议，此条款在必要时将进行修订，修订后的条款、规则一旦公布即取代原服务条款内容及规则并自动生效。如您不同意相关变更，应当立即停止使用TeamFace，如您继续使用，即表示您已接受经修订的服务和规则。',
      ol4: '2、TeamFace向用户提供的基于阿里云的企业服务云平台，帮助用户实现基于云计算的协同互联网服务，服务包括手机客户端（iOS、Android等）、电脑WEB端等多个应用版本的应用服务，用户必须选择与所安装终端设备相匹配的软件版本。',
      ol5: '3、用户在使用TeamFace过程中，必须遵循以下规则：',
      ol6: '5、如用户在使用本网站服务时违反任何上述规定，”汇聚华企”有权要求用户改正或直接采取一切必要的措施（包括但不限于暂停或终止用户使用本服务的权利并追讨因此带来的损失）以减轻用户不当行为造成的影响。',
      ol7: '6、用户须对在TeamFace的注册信息的真实性、合法性、有效性承担全部责任，用户不得冒充他人；不得利用他人的名义发布任何信息；不得恶意使用注册帐户导致其他用户误认；否则“汇聚华企”有权立即停止提供服务，收回其帐号并由用户独自承担由此而产生的一切法律责任。',
      ol8: '7、用户直接或通过各类方式（如 RSS 源和站外 API 引用等）间接使用本服务和数据的行为，都将被视作已无条件接受本协议全部内容；若用户对本协议的任何条款存在异议，请停止使用TeamFace所提供的全部服务。',
      ol9: '8、用户承诺不得以任何方式利用TeamFace直接或间接从事违反中国法律、以及社会公德的行为，TeamFace有权对违反上述承诺的内容予以删除。',
      ol10: '9、用户不得利用本服务制作、上载、复制、发布、传播或者转载如下内容：',
      ol11: '10、TeamFace有权对用户使用情况进行审查和监督，如用户在使用时违反任何上述规定，TeamFace或其授权的人有权要求用户改正或直接采取一切必要的措施（包括但不限于更改或删除用户张贴的内容、暂停或终止用户使用本服务的权利）以减轻用户不当行为造成的影响',
      ol12: '11、TeamFace有权但无义务对用户发布的内容进行审核，有权根据相关证据结合《侵权责任法》、《信息网络传播权保护条例》等法律法规及TeamFace社区指导原则对侵权信息进行处理。',
      ol13: '1、TeamFace的应用程序、源代码、商标、LOGO、界面设计、应用程序编程接口(API)等所关联的所有知识产权均属深圳市汇聚华企科技有限机构（下面简称“我机构”）所有。上述及其他任何本服务包含的内容的知识产权均受到法律保护，未经我机构或相关权利人书面许可，任何人不得以任何形式进行非法使用。',
      ol14: '2、用户应当确保其公开或存储TeamFace相关服务器的内容不存在任何侵犯其他第三方知识产权的情形。若存在本条所述情形，我机构有权根据具体情节针对上述内容，采取包括但不限于限制、屏蔽、删除、修改等手段，由此给网站用户造成的损失由用户自行承担；若我机构因用户存在本条所述行为而向其他第三方承担法律责任的，我机构有权向用户追偿全部损失。',
      ol15: '1、TeamFce将尽可能采取一切措施保护用户数据及个人信息资料安全，只根据用户的行为指示来分发用户的信息，不会向任何第三方公开或共享用户的具体数据。',
      ol16: '2、TeamFace保留使用汇总统计性信息的权利，在不透露单个用户隐私资料的前提下，有权对整个用户数据库进行分析并对用户数据库进行商业上的利用。',
      ol17: 'TeamFace向您发出的任何通知，可采用电子邮件、用户网络区域提示，手机短信或常规信件等方式，且该等通知应自发送之日视为已向用户送达生效。',
      ol18: '1、您理解并同意，在使用TeamFace的过程中，可能会遇到不可抗力等风险因素，使本服务发生中断。 不可抗力是指不能预见、不能克服并不能避免且对一方或双方造成重大影响的客观事件， 包括但不限于由于自然灾害、网络连接故障、黑客、病毒、通讯、电力或其它系统的故障、罢工、劳动争议、战争、动乱、政府行为及等。出现上述情况时，TeamFace将努力在第一时间与相关单位配合，及时进行修复，但是由此给您造成的损失TeamFace均不承担责任。',
      ol19: '2、你理解并同意TeamFace将会尽其商业上的合理努力，保障您在本软件及服务中的数据存储安全；但是并不能就此提供完全保证，包括但不限于以下情形：',
      ol20: '3、用户在使用本软件及服务时，须自行承担如下TeamFace不可掌控的风险内容，包括但不限于：',
      ol21: '1、本协议的生效、解释、执行、管辖、争议的解决均应适用中华人民共和国法律。',
      ol22: '2、如发生TeamFace服务条款与中国法律相抵触时，则这些条款将完全按法律规定重新解释，而其它合法条款则依旧保持对用户产生法律效力和影响。',
      ol23: '3、因本协议引起的或与本协议有关的任何争议，双方可友好协商解决；协商不成，任何一方均可在深圳市南山区人民法院提起诉讼。',
      li1: '遵守中国有关的法律法规；',
      li2: '不得对本网站服务进行任何形式的对其他第三方的再授权使用、销售或转让；',
      li3: '不得为设计开发竞争产品对本网站进行任何形式的反向工程、反向编译、反汇编，或在竞争产品抄袭模仿本服务产品的设计；',
      li4: '不得滥用TeamFace通信功能发送垃圾邮件和短信；',
      li5: '不得对TeamFace的连续服务和商誉构成损害的其他行为，包括对服务器的攻击；',
      li6: '遵守本协议中的全部约定。',
      li7: '危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；',
      li8: '损害国家荣誉和利益的；',
      li9: '煽动民族仇恨、民族歧视，破坏民族团结的；',
      li10: '破坏国家宗教政策，宣扬邪教和封建迷信的；',
      li11: '散布谣言，扰乱社会秩序，破坏社会稳定的；',
      li12: '散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；',
      li13: '侮辱或者诽谤他人，侵害他人合法权益的；',
      li14: '含有法律、行政法规禁止的其他内容的信息。',
      li15: '我机构不对你在本软件及服务中误删数据或储存失败负责，但我们会尽力协助用户处理以减少因此给用户造成的损失和影响。',
      li16: 'Teamface有权根据实际情况自行决定单个用户在本软件及服务中数据的最长储存期限，并在服务器上为其分配数据最大存储空间等。你可根据自己的需要自行备份本软件及服务中的相关数据；',
      li17: '如果你停止使用本软件及服务或服务被终止或取消，TeamFace可以从服务器上永久地删除你的数据。服务停止、终止或取消后，TeamFace没有义务向你返还任何数据。',
      li18: '由于不可抗拒因素可能引起的个人信息丢失、泄漏等风险；',
      li19: '用户必须选择与所安装终端设备相匹配的软件版本，否则，由于软件与终端设备型号不相匹配所导致的任何问题或损害，均由用户自行承担；',
      li20: '用户在使用本软件访问第三方网站时，因第三方网站及相关内容所可能导致的风险，由用户自行承担；',
      li21: '用户发布的内容被他人转发、分享，因此等传播可能带来的风险和责任；',
      li22: '由于无线网络信号不稳定、无线网络带宽小等原因，所引起的登录失败、资料同步不完整、页面打开速度慢等风险。',
      li23: '你在使用本软件第三方提供的产品或服务时，除遵守本协议约定外，还应遵守第三方的用户协议。TeamFace和第三方对可能出现的纠纷在法律规定和约定的范围内各自承担责任。',
      li24: '医疗设施、交通通讯等重要领域。如果因为软件或服务的原因导致上述操作失败而带来的人员伤亡、财产损失和环境破坏等，TeamFace不承担法律责任。',

      content1: '尊敬的用户：',
      content2:
        '欢迎使用，为了使您获得愉悦和安全的服务，在此列明以下服务条款，在使用本服务之前，请您务必审慎阅读、充分理解。',
      content3:
        '如发生下列任何一种情形，TeamFace有权不经通知而中断或终止向您提供的服务，并对相关内容进行保存或披露：',
      content4: '1、您违反相关法律法规或本协议的约定。',
      content5: '2、按照法律规定或主管部门的要求。',
      content6: '3、为保护TeamFace用户及社会公众的权利、财产或人身安全。',
      content7: '4、其他出于安全的原因或其他必要的情况。',
      content8: '尊敬的用户，欢迎您使用TeamFace !',
      content9:
        'TeamFace是由深圳市汇聚华企科技有限机构（以下简称“汇聚华企”）提供，汇聚华企认可并重视用户的隐私，隐私权是您重要的权利。您在使用TeamFace服务时，我们可能会收集和使用您的相关信息。我们希望通过本《隐私政策》向您说明。希望您仔细阅读，在需要时，按照本《隐私政策》的指引，作出您认为适当的选择。',
      content10:
        '您使用或继续使用我们的服务，即意味着同意我们按照本《隐私政策》收集、使用、储存和分享您的相关信息。如对本《隐私政策》或相关事宜有任何问题，请通过TeamFace官网联系方式与我们联系。',
      content11:
        '我们提供服务时，可能会收集、储存和使用下列与您有关的信息。如果您不提供相关信息，可能无法注册成为我们的用户或无法享受我们提供的某些服务，或者无法达到相关服务拟达到的效果。',
      content12:
        '您在注册TeamFace账户或使用时，向我们提供的相关信息，个人信息包括：姓名、电话号码、电子邮件、机构/团队信息包括：机构名称、LOGO、联系方式等以及您在购买服务过程中可能涉及到的帐户信息；',
      content13: '您通过TeamFace向其他方提供的共享信息，以及您使用我们的服务时所储存的信息。',
      content14: '您使用TeamFace时我们可能收集如下信息：',
      content15: 'WEB信息',
      content16:
        '指您使用TeamFace时，我们的WEB服务器会自动采集和汇总有关您的访问信息，包括：相关网页的URL或域、系统及相关软件信息，您所访问的页面及访问日期和时间等。',
      content17: '位置信息',
      content18:
        '指您开启设备定位功能并使用我们基于位置提供的相关服务时，收集的有关您位置的信息，包括：',
      content19:
        '1)您通过具有定位功能的移动设备使用我们的服务时，通过GPS或WiFi等方式收集的您的地理位置信息；',
      content20:
        '2)您或其他用户提供的包含您所处地理位置的实时信息，例如您提供的账户信息中包含的您所在地区信息，您或其他人上传的显示您当前或曾经所处地理位置的共享信息，您或其他人共享的照片包含的地理标记信息；',
      content21: '3)您可以通过关闭定位功能，停止对您的地理位置信息的收集。',
      content22: '我们可能将在向您提供服务的过程之中所收集的信息用作下列用途：',
      content23: '1)向您提供服务。',
      content24:
        '2)在我们提供服务时，用于身份验证、客户服务、安全防范、诈骗监测、存档和备份用途，确保我们向您提供的产品和服务的安全性。',
      content25:
        '3)帮助我们设计新服务，改善我们现有服务，使我们更加了解您如何接入和使用我们的服务，从而评估并增强您对TeamFace的体验感，包括通过识别您的喜好和购习意向，进行营销以及与运营和开发相关的活动。',
      content26: '4)软件认证或管理软件升级，让您参与有关我们产品和服务的调查。',
      content27:
        '为了让您有更好的体验、改善我们的服务或您同意的其他用途，在符合相关法律法规的前提下，我们可能将通过某一项服务所收集的信息，以汇集信息或者个性化的方式，用于我们的其他服务。例如，在您使用我们的一项服务时所收集的信息，可能在另一服务中用于向您提供特定内容，或向您展示与您相关的、非普遍推送的信息。如果我们在相关服务中提供了相应选项，您也可以授权我们将该服务所提供和储存的信息用于我们的其他服务。',
      content28:
        '我们将尽一切可能采取适当的技术手段，保证您可以访问、更新和更正自己的注册信息或使用我们的服务时提供的其他个人信息。在访问、更新、更正和删除前述信息时，我们可能会要求您进行身份验证，以保障账户安全。',
      content29:
        '除以下情形外，未经您同意，我们以及我们的关联机构不会与任何第三方分享您的个人信息。',
      content30:
        '我们以及我们的关联机构，可能将您的个人信息与我们的关联机构、合作伙伴及第三方服务供应商、承包商及代理（例如代表我们发出电子邮件或推送通知的通讯服务提供商、为我们提供位置数据的地图服务供应商）分享（他们可能并非位于您所在的地域），用作下列用途：',
      content31: '1)向您提供我们的服务；',
      content32: '2)实现“ 我们可能如何使用信息 ”部分所述目的；',
      content33: '3)理解、维护和改善我们的服务。',
      content34:
        '如我们或我们的关联机构与任何上述第三方分享您的个人信息，我们将努力确保该等第三方在使用您的个人信息时遵守本《隐私政策》及我们要求其遵守的其他适当的保密和安全措施。',
      content35:
        '随着我们业务的持续发展，我们以及我们的关联机构有可能进行合并、收购、资产转让或类似的交易，您的个人信息有可能作为此类交易的一部分而被转移。我们将在转移前通知您。',
      content36: '我们或我们的关联机构还可能为以下需要而保留、保存或披露您的个人信息：',
      content37: '1)遵守适用的法律法规；',
      content38: '2)遵守法院命令或其他法律程序的规定；',
      content39: '3)遵守相关政府机关的要求。',
      content40:
        '为遵守适用的法律法规、维护社会公共利益，或保护我们的客户、我们或我们的集团机构、其他用户或雇员的人身和财产安全或合法权益所合理必需的用途。',
      content41:
        '我们仅在本《隐私政策》所述目的所必需的期间和法律法规要求的时限内保留您的个人信息。',
      content42:
        '我们使用各种安全技术和程序，以防信息的丢失、不当使用、未经授权阅览或披露。例如，在某些服务中，我们将利用加密技术（例如SSL）来保护您提供的个人信息。但请您理解，由于技术的限制以及可能存在的各种恶意手段，在互联网行业，即便竭尽所能加强安全措施，也不可能始终保证信息百分之百的安全。您需要了解，您接入我们的服务所用的系统和通讯网络，有可能因我们可控范围外的因素而出现问题。',
      content43:
        '我们的多项服务，可让您不仅与自己的社交网络，也与使用该服务的所有用户公开分享您的相关信息，例如，您在我们的服务中所上传或发布的信息（包括您公开的个人信息、您建立的名单）、您对其他人上传或发布的信息作出的回应，以及包括与这些信息有关的位置数据和日志信息。使用我们服务的其他用户也有可能分享与您有关的信息（包括位置数据和日志信息）。特别是，我们的社交媒体服务，是专为使您与世界各地的用户共享信息而设计，您可以使共享信息实时、广泛地传递。只要您不删除共享信息，有关信息会一直留存在公共领域；即使您删除共享信息，有关信息仍可能由其他用户或不受我们控制的非关联第三方独立地缓存、复制或储存，或由其他用户或该等第三方在公共领域保存。',
      content44: '因此，请您谨慎考虑通过我们的服务上传、发布和交流的信息内容。',
      content45:
        '在一些情况下，您可通过我们某些服务的隐私设定来控制有权浏览您共享信息的用户范围。如要求从我们的服务中删除您的相关信息，请通过该特别服务条款提供的方式操作。',
      content46:
        '某些个人信息因其特殊性可能被认为是敏感个人信息，例如您的种族、宗教、个人健康和医疗信息等。相比其他个人信息，敏感个人信息受到更加严格的保护。',
      content47:
        '请注意，您在使用我们的服务时所提供、上传或发布的内容和信息（例如有关您社交活动的照片等信息），可能会泄露您的敏感个人信息。您需要谨慎地考虑，是否在使用我们的服务时披露相关敏感个人信息。',
      content48: '我们可能通过cookies收集和使用您的信息，并将该等信息储存为日志信息。',
      content49: '我们使用自己的cookies目的是为您提供更个性化的用户体验和服务，并用于以下用途：',
      content50:
        '1)住您的身份。例如：cookies有助于我们辨认您作为我们的注册用户的身份，或保存您向我们提供的有关您的喜好或其他信息；',
      content51:
        '2)分析您使用我们服务的情况。例如，我们可利用cookies来了解您使用TeamFace进行什么活动，或哪些服务最受您的欢迎；',
      content52:
        '3)广告优化。Cookies有助于我们根据您的信息，向您提供与您相关的广告而非进行普遍的广告投放。',
      content53:
        '我们为上述目的使用cookies的同时，可能将通过cookies收集的非个人身份信息，经统计加工后提供给广告商或其他合作伙伴，用于分析用户如何使用我们的服务，并用于广告服务。',
      content54:
        '我们的产品和服务上可能会有广告商或其他合作方放置的cookies。这些cookies可能会收集与您相关的非个人身份信息，以用于分析用户如何使用该等服务、向您发送您可能感兴趣的广告，或用于评估广告服务的效果。这些第三方cookies收集和使用该等信息，不受本《隐私政策》约束，而是受相关使用者的隐私政策约束，我们不对第三方的cookies承担责任。',
      content55:
        '您可以通过浏览器设置拒绝或管理cookies。但请注意，如果停用cookies，您有可能无法享受最佳的服务体验，某些服务也可能无法正常使用。同时，您还会收到同样数量的广告，但这些广告与您的相关性会降低。',
      content56:
        '您在使用TeamFace时，我们可能使用您的信息向您的设备发送电子邮件、新闻或推送通知。如您不希望收到这些信息，可以按照我们的相关提示，在设备上选择取消订阅。',
      content57:
        '我们可能在必要时（例如因系统维护而暂停某一项服务时）向您发出与服务有关的公告。您可能无法取消这些与服务有关、性质不属于推广的公告。',
      content58:
        '除某些特定服务外，我们所有的服务均适用本《隐私政策》。这些特定服务将适用特定的隐私政策。',
      content59: '针对某些特定服务的特定隐私政策，将更具体地说明我们在该等服务中如何使用您的信息。',
      content60: '该特定服务的隐私政策构成本《隐私政策》的一部分。',
      content61: '如相关特定服务的隐私政策与本《隐私政策》有不一致之处，适用该特定服务的隐私政策。',
      content62: '1)通过我们的服务而接入的第三方服务（包括任何第三方网站）收集的信息；',
      content63: '2)通过在我们服务中进行广告服务的其他机构或机构所收集的信息。',
      content64: '我们可能适时修订本《隐私政策》的条款，该等修订构成本《隐私政策》的一部分。',
      content65:
        '如该等修订造成您在本《隐私政策》下权利的实质减少，我们将在修订生效前通过在主页上显著位置提示或向您发送电子邮件或以其他方式通知您。在该种情况下，若您继续使用我们的服务，即表示同意受经修订的本《隐私政策》的约束。',
      // 20210910
      content66:
        '4)设备或软件信息，例如您的移动设备、网页浏览器或用于接入我们服务的其他程序所提供的配置信息、您的MAC地址和移动设备所用的电信运营商、系统版本和设备的品牌及型号、识别码等。',
      content67:
        '5)网络接口报错信息，您在使用我们的服务过程中产生的网络报错信息我们需要及时捕获，以便更快的定位问题，提示您的使用体验',
      content68: '6)集成第三方推送和地图（如:小米推送、华为推送、极光推送、百度地图、华为联运 等）',
      content69:
        '5)集成第三方应用 为了更好的服务，进行及时消息提醒，位置地图展现，给你的工作带来方便快捷的操作。',
      content70: '6)获取MAC地址为了系统安全和设备绑定，对的账号安全和数据访问安全做保障。'
    },
    termsService: '',
    rememberAccountpwd: '记住帐号密码',
    wechatWorkLogin: '企业微信登录',
    dingtalkLogin: '钉钉登录',
    loginBrowserTip1: '建议使用',
    loginBrowserTip2: '谷歌',
    loginBrowserTip3: '浏览器'
  }
}
